import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/aov_banner.jpg'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-654a83aa")

_pushScopeId("data-v-654a83aa")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between","margin-top":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "清除缓存", -1)
const _hoisted_11 = { class: "dialogTitle" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "手动生成报告", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("生成报告")
const _hoisted_14 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_20 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_24 = { class: "copyVal" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("复制数据")
const _hoisted_26 = { id: "perf_report" }
const _hoisted_27 = { class: "spacName" }
const _hoisted_28 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_29 = { class: "mainContent" }
const _hoisted_30 = { class: "spacName" }
const _hoisted_31 = { class: "gameTable" }
const _hoisted_32 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_33 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 测试版本： ")
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 报告创建时间: ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 对比版本： ")
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试类型: "),
  /*#__PURE__*/_createVNode("span", null, "客户端性能自动化测试")
], -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_46 = { class: "corePerformance" }
const _hoisted_47 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标风险详情")
], -1)
const _hoisted_48 = { class: "spacName2" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_60 = {
  key: 1,
  style: {"color":"#00b050"}
}
const _hoisted_61 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("核心指标性能趋势")
], -1)
const _hoisted_62 = { class: "spacName" }
const _hoisted_63 = { class: "detailedTest spacName" }
const _hoisted_64 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细测试数据")
], -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("p", { class: "describe" }, [
  /*#__PURE__*/_createVNode("span", null, "灰色"),
  /*#__PURE__*/_createTextVNode("为上个版本数据，白色为当前内网最新版本数据 ")
], -1)
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "detailedTestTable" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_69 = { class: "outerLayerTable outerLayerTable2" }
const _hoisted_70 = { class: "Table_Left" }
const _hoisted_71 = { style: {"height":"37px"} }
const _hoisted_72 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", null, "测试指标")
], -1)
const _hoisted_73 = { class: "Table_Right" }
const _hoisted_74 = { id: "Table_Right_div" }
const _hoisted_75 = { class: "Table_Right_in" }
const _hoisted_76 = {
  style: {"height":"37px"},
  colspan: 4
}
const _hoisted_77 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = {
  key: 2,
  style: {"border-right":"none","width":"0"}
}
const _hoisted_81 = /*#__PURE__*/_createVNode("td", null, "old", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("td", null, "new", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("td", null, "趋势", -1)
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = {
  key: 2,
  style: {"border-right":"none","width":"0"}
}
const _hoisted_87 = { key: 3 }
const _hoisted_88 = { key: 4 }
const _hoisted_89 = { key: 5 }
const _hoisted_90 = { key: 6 }
const _hoisted_91 = { key: 1 }
const _hoisted_92 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, { style: {"display":"flex"} }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.name_search,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name_search = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_5,
                                _hoisted_6
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      size: "mini",
                      type: "primary",
                      onClick: _ctx.generateReportsManually,
                      disabled: _ctx.get_is_super,
                      style: {"height":"28px"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_tooltip, {
                          effect: "dark",
                          content: "暂无管理员权限",
                          placement: "top",
                          disabled: !_ctx.get_is_super
                        }, {
                          default: _withId(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: _ctx.clear,
                        disabled: _ctx.get_is_super,
                        style: {"height":"28px","margin-left":"auto"}
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_tooltip, {
                            effect: "dark",
                            content: "暂无管理员权限",
                            placement: "top",
                            disabled: !_ctx.get_is_super
                          }, {
                            default: _withId(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ]),
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogFormVisible,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogFormVisible = $event)),
                    width: "790px"
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.generateReport,
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.generateReportVersion,
                        "label-position": "top",
                        size: "small"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "旧版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.oldEdition,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateReportVersion.oldEdition = $event)),
                                id: "old_version",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "新版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.newEdition,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateReportVersion.newEdition = $event)),
                                id: "new_version",
                                placeholder: "请选择",
                                onChange: _ctx.selectVersion
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_version_options, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "场景" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.generateReportVersion.scenetion,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.generateReportVersion.scenetion = $event)),
                                multiple: "",
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.game_scene_version, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.scene_id_id,
                                      label: item.scene_id__chinese,
                                      value: item.scene_id_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_14, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18,
                                    _hoisted_19,
                                    _hoisted_20,
                                    _hoisted_21
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_22
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_23
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", {
                    class: 
                !_ctx.get_is_super
                  ? 'versionGeneration'
                  : 'versionGeneration versionGeneration2'
              
                  }, [
                    _createVNode("p", null, [
                      _createVNode("b", null, _toDisplayString("AOV版本号: " +
                    _ctx.new_report.new_version +
                    " - " +
                    "时间: " +
                    _ctx.new_report.create_date), 1)
                    ]),
                    _createVNode("div", _hoisted_24, [
                      (!_ctx.get_is_super)
                        ? (_openBlock(), _createBlock(_component_el_form, {
                            key: 0,
                            inline: true,
                            model: _ctx.copyVal,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              (_ctx.new_report.task_record_id != null)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    label: "当前记录id:",
                                    class: "iTemWidth2"
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(_ctx.new_report.task_record_id), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_form_item, {
                                label: "任务记录id",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    onChange: _ctx.equipmentUpdate,
                                    modelValue: _ctx.copyVal.taskRecordId,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.copyVal.taskRecordId = $event)),
                                    placeholder: "请选择任务记录id",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordQuery, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.id,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["onChange", "modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "设备数据",
                                class: "iTemWidth"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.copyVal.deviceVal,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.copyVal.deviceVal = $event)),
                                    placeholder: "请选择设备数据",
                                    filterable: ""
                                  }, {
                                    default: _withId(() => [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.TaskRecordDevices, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.id,
                                          label: item.model.model,
                                          value: item.id
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_popconfirm, {
                                    title: "确认复制数据吗？",
                                    onConfirm: _ctx.CopyBtn,
                                    placement: "top"
                                  }, {
                                    reference: _withId(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        disabled: _ctx.interfaceDisabled
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_25
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["onConfirm"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2),
                  _createVNode("div", _hoisted_26, [
                    _withDirectives(_createVNode("div", _hoisted_27, [
                      _hoisted_28
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ]),
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _withDirectives(_createVNode("table", _hoisted_31, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_32, [
                              _createVNode("img", {
                                src: _ctx.get_core_data.project.icon
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("td", _hoisted_33, " 【" + _toDisplayString(_ctx.get_core_data.project.project_name) + "】 ", 1)
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _createVNode("p", null, [
                                _hoisted_34,
                                (
                              _ctx.modelVal === '安卓' || _ctx.modelVal === '安卓/iOS'
                            )
                                  ? (_openBlock(), _createBlock("span", _hoisted_35, " Android " + _toDisplayString(_ctx.get_core_data.able_versions.android_new_version ||
                              "--"), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.modelVal === '安卓/iOS')
                                  ? (_openBlock(), _createBlock("span", _hoisted_36, "，"))
                                  : _createCommentVNode("", true),
                                (_ctx.modelVal === 'iOS' || _ctx.modelVal === '安卓/iOS')
                                  ? (_openBlock(), _createBlock("span", _hoisted_37, " iOS " + _toDisplayString(_ctx.get_core_data.able_versions.ios_new_version ||
                              "--"), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createVNode("td", null, [
                              _hoisted_38,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.create_date), 1)
                            ]),
                            _createVNode("td", null, [
                              _hoisted_39,
                              _createVNode("span", null, _toDisplayString(_ctx.new_report.creator), 1)
                            ])
                          ]),
                          _createVNode("tr", null, [
                            _createVNode("td", null, [
                              _createVNode("p", null, [
                                _hoisted_40,
                                (
                              _ctx.modelVal === '安卓' || _ctx.modelVal === '安卓/iOS'
                            )
                                  ? (_openBlock(), _createBlock("span", _hoisted_41, " Android " + _toDisplayString(_ctx.get_core_data.able_versions.android_old_version ||
                              "--"), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.modelVal === '安卓/iOS')
                                  ? (_openBlock(), _createBlock("span", _hoisted_42, "，"))
                                  : _createCommentVNode("", true),
                                (_ctx.modelVal === 'iOS' || _ctx.modelVal === '安卓/iOS')
                                  ? (_openBlock(), _createBlock("span", _hoisted_43, " iOS " + _toDisplayString(_ctx.get_core_data.able_versions.ios_old_version ||
                              "--"), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _hoisted_44,
                            _createVNode("td", null, [
                              _hoisted_45,
                              _createVNode("span", null, _toDisplayString(_ctx.modelVal), 1)
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode("div", _hoisted_48, [
                          (_ctx.corePerformance.length > 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_49, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.corePerformance, (item) => {
                                  return (_openBlock(), _createBlock(_Fragment, {
                                    key: item.title
                                  }, [
                                    (_ctx.corePerformance.length > 1)
                                      ? (_openBlock(), _createBlock("h6", _hoisted_50, _toDisplayString(item.title), 1))
                                      : _createCommentVNode("", true),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_set.content.core_index, (setting) => {
                                      return (_openBlock(), _createBlock(_component_el_table, {
                                        data: item.data,
                                        key: setting
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_el_table_column, {
                                            prop: "scene",
                                            label: "测试场景"
                                          }, {
                                            default: _withId((scope) => [
                                              (scope.$index === 0)
                                                ? (_openBlock(), _createBlock("span", _hoisted_51, "基准"))
                                                : (_openBlock(), _createBlock("span", _hoisted_52, _toDisplayString(scope.row?.scene), 1))
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_el_table_column, {
                                            label: _ctx.get_field(setting) + '趋势'
                                          }, {
                                            default: _withId(() => [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.compare, (device, index) => {
                                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                                  key: Number(index),
                                                  label: _ctx.get_device_label(device, Number(index))
                                                }, {
                                                  default: _withId((scope) => [
                                                    (scope.$index === 0)
                                                      ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                                          (setting === 'avg_fps')
                                                            ? (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(scope.row.new[index].data?.standard_avg_fps), 1))
                                                            : _createCommentVNode("", true),
                                                          (setting === 'max_pss')
                                                            ? (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(scope.row.new[index].data?.standard_max_pss), 1))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : (_openBlock(), _createBlock("div", _hoisted_56, [
                                                          _createVNode(_component_el_tooltip, {
                                                            effect: "dark",
                                                            placement: "top"
                                                          }, {
                                                            content: _withId(() => [
                                                              _createVNode("span", null, _toDisplayString(scope.row.new[index].data
                                            ?.game_version || "--") + " 对比 " + _toDisplayString(scope.row.old[index].data
                                            ?.game_version || "--"), 1)
                                                            ]),
                                                            default: _withId(() => [
                                                              _createVNode("span", {
                                                                style: 
                                        _ctx.compore_num(
                                          scope.row.new[index].data?.[setting],
                                          scope.row.old[index].data?.[setting],
                                          setting,
                                          scope.row,
                                          scope.row.new[index]
                                        )[3]
                                      
                                                              }, _toDisplayString(scope.row.new[index].data?.[setting] ||
                                        "--"), 5)
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          (
                                      _ctx.compore_num(
                                        scope.row.new[index].data?.[setting],
                                        scope.row.old[index].data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[0] !== ''
                                    )
                                                            ? (_openBlock(), _createBlock("span", {
                                                                key: 0,
                                                                id: "blodTypeId",
                                                                style: 
                                      'color:' +
                                      _ctx.compore_num(
                                        scope.row.new[index].data?.[setting],
                                        scope.row.old[index].data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[2]
                                    
                                                              }, _toDisplayString(_ctx.compore_num(
                                        scope.row.new[index].data?.[setting],
                                        scope.row.old[index].data?.[setting],
                                        setting,
                                        scope.row,
                                        scope.row.new[index]
                                      )[0]), 5))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["label"]),
                                          _createVNode(_component_el_table_column, {
                                            prop: "trend",
                                            label: "趋势风险"
                                          }, {
                                            default: _withId((scope) => [
                                              (scope.$index === 0)
                                                ? (_openBlock(), _createBlock("div", _hoisted_57, "--"))
                                                : (_openBlock(), _createBlock("div", _hoisted_58, [
                                                    (scope.row?.[setting] === '高风险')
                                                      ? (_openBlock(), _createBlock("span", _hoisted_59, _toDisplayString(scope.row?.[setting]), 1))
                                                      : (_openBlock(), _createBlock("span", _hoisted_60, "低风险"))
                                                  ]))
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock(_component_el_empty, {
                                key: 1,
                                description: "无数据"
                              }))
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ]),
                      _createVNode("div", null, [
                        _hoisted_61,
                        _createVNode("div", _hoisted_62, [
                          _createVNode("div", null, [
                            (_ctx.get_core_data.all_echart_data.length > 0)
                              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.get_core_data.all_echart_data, (item, index) => {
                                  return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                                    key: index,
                                    class: "spacName2"
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", {
                                        id: 'Performance_trends' + index,
                                        style: {"height":"600px"}
                                      }, null, 8, ["id"])
                                    ]),
                                    _: 2
                                  }, 1536)), [
                                    [_directive_loading, _ctx.loading]
                                  ])
                                }), 128))
                              : (_openBlock(), _createBlock(_component_el_empty, {
                                  key: 1,
                                  description: "无数据"
                                }))
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_63, [
                        _hoisted_64,
                        _hoisted_65,
                        (_ctx.get_core_data.report_list2.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_66, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_core_data.report_list2, (scene) => {
                                return _withDirectives((_openBlock(), _createBlock("div", {
                                  key: scene.scene_id,
                                  class: "spacName2"
                                }, [
                                  _createVNode("div", _hoisted_67, [
                                    _createVNode("h5", null, [
                                      _hoisted_68,
                                      _createTextVNode(" " + _toDisplayString(scene.scene), 1)
                                    ]),
                                    _createVNode("table", _hoisted_69, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", _hoisted_70, [
                                          _createVNode("table", null, [
                                            _createVNode("tr", null, [
                                              _createVNode("td", _hoisted_71, _toDisplayString(scene.scene), 1)
                                            ]),
                                            _hoisted_72,
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testData, (item, index) => {
                                              return (_openBlock(), _createBlock("tr", { key: index }, [
                                                _createVNode("td", null, _toDisplayString(item.label), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _createVNode("td", _hoisted_73, [
                                          _createVNode("div", _hoisted_74, [
                                            _createVNode("table", null, [
                                              _createVNode("tr", null, [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(scene.device_list, (device, d_index) => {
                                                  return (_openBlock(), _createBlock("td", { key: d_index }, [
                                                    _createVNode("table", _hoisted_75, [
                                                      _createVNode("tr", null, [
                                                        _createVNode("td", _hoisted_76, [
                                                          _createTextVNode(_toDisplayString(device) + " ", 1),
                                                          _hoisted_77,
                                                          _createVNode("span", null, _toDisplayString(_ctx.Level.filter(
                                                (item1) =>
                                                  item1.value ===
                                                  scene.new[d_index].level
                                              )[0]?.label), 1)
                                                        ])
                                                      ]),
                                                      _createVNode("tr", null, [
                                                        (d_index === 0)
                                                          ? (_openBlock(), _createBlock("td", _hoisted_78, "基准"))
                                                          : (
                                              d_index >= 1 &&
                                              scene.new[d_index].level !==
                                                scene.new[d_index - 1].level
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_79, " 基准 "))
                                                            : (_openBlock(), _createBlock("td", _hoisted_80)),
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.old[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_81
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_component_el_tooltip, {
                                                          effect: "dark",
                                                          placement: "top"
                                                        }, {
                                                          content: _withId(() => [
                                                            _createVNode("span", null, _toDisplayString(scene.new[d_index].data
                                                  ?.game_version || "--"), 1)
                                                          ]),
                                                          default: _withId(() => [
                                                            _hoisted_82
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _hoisted_83
                                                      ]),
                                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testData, (i, i_index) => {
                                                        return (_openBlock(), _createBlock("tr", { key: i_index }, [
                                                          (
                                              d_index === 0 &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== '' &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== null &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_84, _toDisplayString(scene.standard[d_index][i.value]), 1))
                                                            : (
                                              d_index >= 1 &&
                                              scene.new[d_index].level !==
                                                scene.new[d_index - 1].level &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== '' &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== null &&
                                              scene.standard[d_index][
                                                i.value
                                              ] !== undefined
                                            )
                                                              ? (_openBlock(), _createBlock("td", _hoisted_85, _toDisplayString(scene.standard[d_index][i.value]), 1))
                                                              : (_openBlock(), _createBlock("td", _hoisted_86)),
                                                          (
                                              scene.old[d_index].data?.[
                                                i.value
                                              ] !== '' &&
                                              scene.old[d_index].data?.[
                                                i.value
                                              ] !== null &&
                                              scene.old[d_index].data?.[
                                                i.value
                                              ] !== undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_87, _toDisplayString(scene.old[d_index].data?.[i.value]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_88, "--")),
                                                          (
                                              scene.new[d_index].data?.[
                                                i.value
                                              ] !== '' &&
                                              scene.new[d_index].data?.[
                                                i.value
                                              ] !== null &&
                                              scene.new[d_index].data?.[
                                                i.value
                                              ] !== undefined
                                            )
                                                            ? (_openBlock(), _createBlock("td", _hoisted_89, _toDisplayString(scene.new[d_index].data?.[i.value]), 1))
                                                            : (_openBlock(), _createBlock("td", _hoisted_90, "--")),
                                                          _createVNode("td", {
                                                            style: 
                                              'color: ' +
                                              _ctx.compore_num(
                                                scene.new[d_index].data?.[
                                                  i.value
                                                ],
                                                scene.old[d_index].data?.[
                                                  i.value
                                                ],
                                                i.value
                                              )[4]
                                            
                                                          }, _toDisplayString(_ctx.compore_num(
                                                scene.new[d_index].data?.[
                                                  i.value
                                                ],
                                                scene.old[d_index].data?.[
                                                  i.value
                                                ],
                                                i.value
                                              )[0] || "--"), 5)
                                                        ]))
                                                      }), 128))
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 512)), [
                                  [_directive_loading, _ctx.loading]
                                ])
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_91, [
                              _createVNode(_component_el_empty, { description: "无数据" })
                            ]))
                      ])
                    ])
                  ])
                ]),
                _hoisted_92
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})